(() => {
  const key = 'vavoom:favorites:v1';
  let volatile = [];
  let lastTrigger;
  let renderId = 0;
  const get = () => {
    try {
      const data = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(data) ? [...new Set(data.filter(h => typeof h === 'string' && /^[a-z0-9-]+$/.test(h)))].slice(0, 100) : [];
    } catch { return volatile; }
  };
  const sync = () => {
    const saved = get();
    document.querySelectorAll('[data-vv-save]').forEach(button => {
      const active = saved.includes(button.dataset.vvSave);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? button.dataset.savedLabel : button.dataset.saveLabel);
      const text = button.querySelector('[data-vv-save-text]');
      if (text && text.textContent !== button.getAttribute('aria-label')) text.textContent = button.getAttribute('aria-label');
    });
  };
  const set = saved => {
    volatile = saved;
    try { localStorage.setItem(key, JSON.stringify(saved)); }
    catch { const status = document.getElementById('vv-status'); if (status) status.textContent = status.dataset.error; }
    sync();
  };
  const render = async () => {
    const dialog = document.getElementById('vv-favorites');
    if (!dialog) return;
    const list = dialog.querySelector('[data-vv-favorites-list]');
    const saved = get();
    const version = ++renderId;
    list.replaceChildren();
    dialog.querySelector('[data-vv-empty]').hidden = saved.length > 0;
    if (!saved.length) return;
    list.textContent = dialog.dataset.loading;
    const root = dialog.dataset.root.replace(/\/?$/, '/');
    const products = await Promise.all(saved.map(async handle => {
      try {
        const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`);
        if (!response.ok) throw new Error();
        return {handle, product: await response.json()};
      } catch { return {handle}; }
    }));
    if (version !== renderId) return;
    list.replaceChildren();
    for (const {handle, product} of products) {
      const row = document.createElement('article'); row.className = 'vv-saved-item';
      const link = document.createElement('a'); link.href = `${root}products/${encodeURIComponent(handle)}`;
      if (product?.featured_image) {
        const img = document.createElement('img'); const imageUrl = new URL(product.featured_image, location.origin); imageUrl.searchParams.set('width', '168'); img.src = imageUrl.href; img.alt = product.title; img.width = 84; img.height = 112; img.loading = 'lazy'; link.append(img);
      }
      const title = document.createElement('span'); title.textContent = product?.title || dialog.dataset.unavailable; link.append(title);
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = dialog.dataset.removeLabel;
      remove.addEventListener('click', () => { set(get().filter(h => h !== handle)); render(); });
      row.append(link, remove); list.append(row);
    }
  };
  const close = dialog => {
    dialog.close();
    if (!document.querySelector('.vv-drawer[open]')) document.documentElement.classList.remove('vv-drawer-open');
  };
  document.addEventListener('click', event => {
    const save = event.target.closest('[data-vv-save]');
    if (save) {
      event.preventDefault(); event.stopPropagation();
      const saved = get(); const handle = save.dataset.vvSave;
      set(saved.includes(handle) ? saved.filter(h => h !== handle) : [...saved, handle].slice(-100));
      return;
    }
    const open = event.target.closest('[data-vv-open]');
    if (open) {
      const dialog = document.getElementById(`vv-${open.dataset.vvOpen}`);
      if (!dialog) return;
      event.preventDefault();
      if (!open.closest('.vv-drawer')) lastTrigger = open;
      document.querySelectorAll('.vv-drawer[open]').forEach(close);
      dialog.showModal(); document.documentElement.classList.add('vv-drawer-open');
      if (open.dataset.vvOpen === 'favorites') render();
    }
    const closeButton = event.target.closest('[data-vv-close]');
    if (closeButton) close(closeButton.closest('dialog'));
    if (event.target.matches('.vv-drawer')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close(event.target);
    }
  }, true);
  document.querySelectorAll('.vv-drawer').forEach(dialog => dialog.addEventListener('close', () => {
    if (!document.querySelector('.vv-drawer[open]')) { document.documentElement.classList.remove('vv-drawer-open'); lastTrigger?.focus(); }
  }));
  window.addEventListener('storage', () => { sync(); if (document.getElementById('vv-favorites')?.open) render(); });
  document.addEventListener('shopify:section:load', sync);
  const observer = new MutationObserver(records => { if (records.some(r => r.addedNodes.length)) sync(); });
  observer.observe(document.body, {childList:true, subtree:true});
  sync();
})();
